export default [
  {
    img: '',
    title: '2022',
    content: `Kami pertama kali berkenalan melalui Instagram pada 4 Desember 2022. Setelah saling mengikuti dan berkomunikasi lewat _direct message_, kami bertemu langsung untuk pertama kali pada 18 Desember 2022 di Gereja Katedral Semarang. Sejak itu, kami terus berhubungan dan saling mengenal.`,
  },
  {
    img: '',
    title: '2023',
    content: `Kedekatan kami berlanjut meski berbeda kota. Lucky yang studi di Semarang, sementara Betha di Yogyakarta, sering bertemu saat weekend. Kami berusaha meluangkan waktu di tengah kesibukan masing-masing, terutama Lucky yang sebagian besar waktunya di ruang operasi RS Kariadi. Pada akhir 2023, setelah Betha menyelesaikan studinya dan kembali ke Semarang, kami memutuskan untuk serius dalam hubungan ini.`,
  },
  {
    img: '',
    title: '2024',
    content: `Pada 14 Januari 2024, keluarga kami bertemu untuk pertama kalinya, dan keluarga Lucky menyatakan niat untuk membawa hubungan kami ke jenjang yang lebih serius. Kami melangsungkan pertunangan pada 20 Juli 2024, dihadiri oleh keluarga dan teman-teman terdekat, dan merencanakan pemberkatan pernikahan pada 28 Desember 2024`,
  },
  
];
